/*
 *
 * EmailNotifications reducer
 *
 */
import produce from 'immer';
import {
  CUSTOMER_NOTIFICATIONS,
  MERCHANT_NOTIFICATIONS,
  SUCCESS_RATE_ALERTS,
} from 'utils/constants';
import {
  DEFAULT_ACTION,
  SET_ACTIVE_NAVIGATION,
  UPDATE_ALL_EMAILS_DATA,
  ENABLE_LOADER,
  DISABLE_LOADER,
  HANDLE_ALL_EMAILS_RESPONSE,
  HANDLE_REMOVE_EMAIL,
  HANDLE_UPDATE_EMAIL_CHANNEL_STATUS_RESPONSE,
  HANDLE_ADD_BULK_EMAIL_RESPONSE,
  HANDLE_UPDATE_CUSTOMER_NOTIFICATIONS_STATUS,
  SET_ERROR_IN_ADDING_RECIPIENT,
  HANDLE_UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS,
  SMS,
  REFUND_EMAILS,
  DELETED,
} from './constants';
import { filterRefundEmails } from './helper';

export const initialState = {
  isLoading: false,
  receipientAdded: false,
  tabs: {
    [MERCHANT_NOTIFICATIONS]: {
      data: [],
    },
    [CUSTOMER_NOTIFICATIONS]: {
      data: [],
    },
    [SUCCESS_RATE_ALERTS]: {
      data: [],
    },
  },
  customerEmailNotifications: {},
  customerSmsNotifications: {},
  errorInAddingRecipient: '',
  deletedRefundEmails: [],
};

/* eslint-disable default-case, no-param-reassign */
const emailNotificationsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_ACTIVE_NAVIGATION: {
        draft.activeNavigation = action.data;
        break;
      }
      case UPDATE_ALL_EMAILS_DATA: {
        const { activeNavigation, data } = action.data;
        draft.tabs[activeNavigation].data = data;
        break;
      }
      case HANDLE_ALL_EMAILS_RESPONSE: {
        const { data, activeNavigation } = action.data;
        draft.isLoading = false;
        draft.receipientAdded = false;
        draft.errorInAddingRecipient = '';
        if (activeNavigation === CUSTOMER_NOTIFICATIONS) {
          draft.customerEmailNotifications = {
            ...draft.customerEmailNotifications,
            ...data,
          };
        } else {
          const { data: filteredData, deletedEmails } = filterRefundEmails(
            data,
          );
          draft.tabs[activeNavigation].data = filteredData;
          draft.deletedRefundEmails = deletedEmails;
        }
        break;
      }
      case HANDLE_REMOVE_EMAIL: {
        const { data, activeNavigation } = action.data;
        const { email, type } = data;
        const activeNavigationData = draft.tabs[activeNavigation].data;
        const index = activeNavigationData.findIndex(obj => obj.id === type);
        if (index !== -1)
          activeNavigationData[index].emails = activeNavigationData[
            index
          ].emails.filter(obj => obj.email !== email);
        if (type === REFUND_EMAILS)
          draft.deletedRefundEmails.push({ ...data, status: DELETED });
        draft.isLoading = false;
        break;
      }
      case HANDLE_UPDATE_EMAIL_CHANNEL_STATUS_RESPONSE: {
        const {
          data: { enabled, type },
          activeNavigation,
        } = action.data;
        const activeNavigationData = draft.tabs[activeNavigation].data;
        const index = activeNavigationData.findIndex(obj => obj.id === type);
        if (index !== -1) activeNavigationData[index].enabled = enabled;
        draft.isLoading = false;
        break;
      }
      case HANDLE_UPDATE_CUSTOMER_NOTIFICATIONS_STATUS: {
        const { data } = action.data;
        draft.customerEmailNotifications = {
          ...draft.customerEmailNotifications,
          ...data,
        };
        draft.isLoading = false;
        break;
      }
      case HANDLE_ADD_BULK_EMAIL_RESPONSE: {
        draft.receipientAdded = true;
        draft.isLoading = false;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case SET_ERROR_IN_ADDING_RECIPIENT: {
        draft.errorInAddingRecipient = action.data;
        break;
      }
      case HANDLE_UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS: {
        const {
          data: { notificationTypeResponse },
        } = action;
        const {
          notificationType,
          notificationChannel,
          isActive,
        } = notificationTypeResponse;

        const notifications =
          notificationChannel === SMS
            ? draft.customerSmsNotifications
            : draft.customerEmailNotifications;

        notifications[notificationType] = isActive;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default emailNotificationsReducer;
